var map = {
	"./de.json": 372327,
	"./en.json": 130701,
	"./es.json": 250576,
	"./fr.json": 205577,
	"./it.json": 906202,
	"./ja.json": 158937,
	"./ko.json": 991139,
	"./pl.json": 823223,
	"./pt.json": 442675,
	"./ru.json": 650058,
	"./uk.json": 375971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969533;